var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0995529634,2.27452269 L2.20834841,0.453511371 C2.39293571,0.294097248 2.68385899,0.423509645 2.68385899,0.671143701 L2.68385899,1.63030032 C4.60843857,1.65233434 6.13453675,2.03805541 6.13453675,3.86195427 C6.13453675,4.59811084 5.66029621,5.327402 5.13608075,5.70868991 C4.97249705,5.82767839 4.73936064,5.67834072 4.79967561,5.48546221 C5.34296565,3.74799804 4.54198906,3.28673348 2.68385899,3.25999073 L2.68385899,4.31334606 C2.68385899,4.56136352 2.39270806,4.69020081 2.20834841,4.53097839 L0.0995529634,2.70978735 C-0.0330944445,2.59522005 -0.0332741673,2.38924574 0.0995529634,2.27452269 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.7d9b7ef75de8f6460ddbd349ec26585e.svg";
export { ForwardRef as ReactComponent };